import { handlePostRequest } from "../hooks/api";

export async function createUserSupport(payload) {
  const endpoint = "/contactus/createUserInquiry";
  const response = await handlePostRequest(endpoint, payload, {}, false);

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
export async function createBusinessInquiry(payload) {
  const endpoint = "/contactus/createBusinessInquiry";
  const response = await handlePostRequest(endpoint, payload, {}, false);

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
